import { render, staticRenderFns } from "./PaymentMethodSelect.vue?vue&type=template&id=754188ed&"
import script from "./PaymentMethodSelect.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports